import React, { useState, Fragment } from 'react';
import { Button } from 'reactstrap';
import { UploadIExternalImages } from './UploadIExternalImages';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function UploadExternalImagesButton({
    id,
    propertyId,
    parentLoadData
}) {
    const [isUpdating, setIsUpdating] = useState(false);
    return (
        <Fragment>
            <Button
                style={{ marginLeft : '1rem'}}
                color="secondary"
                className="add-button"
                size="xs"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                <FontAwesomeIcon className='mb-0' icon={faPlus} />
                <span> </span>
                Use External Images
            </Button>

            {isUpdating && (
                <UploadIExternalImages
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Add External Image"
                    visible={isUpdating}
                    propertyId={propertyId}
                    parentLoadData={parentLoadData}

                />
            )}
        </Fragment>
    );
}

